module.exports = __webpack_public_path__ + "img/service_intro_03@2x.69664503.png";